import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { services } from "../lib/data";

export default function ServicesGrid() {
  return (
    <section id="services" className="relative py-28 px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-16">
          <span className="section-label" data-testid="services-label">Our Services</span>
          <h2 className="text-4xl sm:text-5xl font-black tracking-tighter mt-5">
            Twelve ways to <span className="gradient-text">compound</span> your capital
          </h2>
          <p className="mt-5 text-slate-400 text-base sm:text-lg">
            From your first ₹500 SIP to multi-crore wealth structures — every offering is built around tax efficiency,
            transparency and SEBI-compliant execution.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, i) => (
            <motion.div
              key={s.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className="glass rounded-2xl p-7 card-glow transition-all duration-300 group relative overflow-hidden"
              data-testid={`service-card-${s.id}`}
            >
              <div className="absolute -top-12 -right-12 w-32 h-32 rounded-full bg-blue-600/10 blur-2xl group-hover:bg-blue-500/20 transition-colors" />
              <div className="relative">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-blue-600/20 to-indigo-600/10 border border-blue-500/30 flex items-center justify-center mb-5">
                  <s.Icon className="w-5 h-5 text-blue-400" strokeWidth={2} />
                </div>
                <h3 className="text-xl font-bold tracking-tight mb-2">{s.title}</h3>
                <p className="text-sm text-slate-400 leading-relaxed">{s.desc}</p>
                <a
                  href="#contact"
                  className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-blue-400 hover:text-blue-300 group/link"
                  data-testid={`service-learn-${s.id}`}
                >
                  Learn More
                  <ArrowUpRight className="w-4 h-4 group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5 transition-transform" />
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
